// Categoria inativa: flag do ERP (ativo = 0) ou marcação "(inativa)/(inativo)/(inativas)" no nome.
// Mesma regra do backend (DreIndicatorsAiService.IsMarkedInactive) — categorias assim não entram no DFC.
const MARKED_INACTIVE = /\(\s*inativ[ao]s?\s*\)/i;

const normalizeCode = (value) => (value === undefined || value === null ? '' : String(value).trim());

export const isInactiveCategory = (category) => {
  if (!category) return false;
  const ativo = category.ativo ?? category.Ativo;
  if (ativo === 0 || ativo === '0' || ativo === false) return true;
  return MARKED_INACTIVE.test(String(category.descricao ?? category.Descricao ?? ''));
};

/** Set com os códigos das categorias inativas da lista. */
export const getInactiveCategoryCodes = (categories) =>
  new Set(
    (Array.isArray(categories) ? categories : [])
      .filter(isInactiveCategory)
      .map((c) => normalizeCode(c.codCategoria ?? c.CodCategoria))
      .filter(Boolean),
  );

/** Remove das linhas de configuração as que apontam para categoria inativa. */
export const withoutInactiveCategories = (rows, inactiveCodes) =>
  (Array.isArray(rows) ? rows : []).filter(
    (row) => !inactiveCodes.has(normalizeCode(row.codCategoria ?? row.CodCategoria)),
  );